import BlInputNumberAv from './BlInputNumberAv.vue'

BlInputNumberAv.install = function(Vue) {
  Vue.component(BlInputNumberAv.name, BlInputNumberAv)
}

export default BlInputNumberAv
